import { api } from "@/apiInstance";
import { endpoints } from "@/endpoints";
import { courseBaseByIdQueryOptions, courseByIdQueryOptions } from "@/queries/courses";
import { useQueryClient, useMutation } from "@tanstack/react-query";
import { EditBasicCourseRequest } from "@vixi/types";

export const useBasicEditCourse = () => {
  const queryClient = useQueryClient();

  const mutationFn = async (body: EditBasicCourseRequest) => {
    const response = await api.post(endpoints.editCourse, body);

    queryClient.invalidateQueries({
      queryKey: courseBaseByIdQueryOptions(queryClient, body.courseId).queryKey,
    });
    queryClient.invalidateQueries({
      queryKey: courseByIdQueryOptions(queryClient, body.courseId).queryKey,
    });

    return response.data as boolean;
  };

  return useMutation({
    mutationKey: ["edit-course"],
    mutationFn,
    retry: 2,
  });
};
